module.exports = __webpack_public_path__ + "static/media/bathroom-white.99fa47d5.svg";